<template>
	<v-sheet class="pa-12" rounded>
		<v-card class="mx-auto px-6 py-8" maxWidth="600">
			<h1>Register</h1>
			<v-form>
				<v-row>
					<v-col>
						<v-text-field v-model="email" type="text" label="E-Mail" />
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field v-model="username" type="text" label="Username" />
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field v-model="firstname" type="text" label="Firstname" />
					</v-col>
					<v-col>
						<v-text-field v-model="lastname" type="text" label="Lastname" />
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<AirportInput
							@returnValue="updateBaseAirport"
							label="Base Airport"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field v-model="password" type="password" label="Password" />
					</v-col>
					<v-col>
						<v-text-field
							v-model="password2"
							type="password"
							label="Password Repeat"
						/>
					</v-col>
				</v-row>
				<v-btn @click="onSubmit">Register</v-btn>
				<v-btn @click="$router.push('/login')">Login</v-btn>
			</v-form>
		</v-card>
	</v-sheet>
</template>

<script>
import axios from "axios";
import AirportInput from "@/components/AirportInput";

export default {
	components: {
		AirportInput,
	},
	data: () => {
		return {
			firstname: "",
			lastname: "",
			password: "",
			password2: "",
			username: "",
			email: "",
			baseAirport: "",
		};
	},
	methods: {
		updateBaseAirport(val) {
			this.baseAirport = val;
		},
		onSubmit(event) {
			event.preventDefault();
			if (
				!this.firstname ||
				!this.lastname ||
				!this.password ||
				!this.password2 ||
				!this.username ||
				!this.email ||
				!this.baseAirport
			) {
				alert("Please enter data");
				return;
			}
			axios
				.post(process.env.VUE_APP_BACKEND_URL + "/auth/register", {
					username: this.username,
					password: this.password,
					email: this.email,
					firstname: this.firstname,
					lastname: this.lastname,
					baseAirport: this.baseAirport.value,
				})
				.then(() => {
					this.$router.push("/login");
				})
				.catch((e) => {
					console.log(e);
				});
		},
	},
};
</script>

<style></style>
